import { FC, memo } from 'react';

import Typography from '@material-ui/core/Typography';
import { Skeleton } from '@material-ui/lab';
import clsx from 'clsx';

import { Paper } from '../paper/Paper';
import { useStyles } from './ProgressBar.styles';
import { ProgressBarSkeletonProps } from './ProgressBar.types';

export const ProgressBarSkeleton: FC<ProgressBarSkeletonProps> = memo(({ hideActions, hideNextStep, classes }) => {
  const styles = useStyles({});

  return (
    <Paper variant="outlined" className={classes?.paper}>
      <div className={clsx(styles.wrapper, classes?.wrapper)}>
        <div className={styles.content}>
          <Typography variant="h6" component="span" className={styles.stepCount}>
            <Skeleton variant="text" animation="wave" width={100} />
          </Typography>

          <div className={styles.titleRow}>
            <Typography variant="h4" className={styles.title}>
              <Skeleton variant="text" animation="wave" width={160} />
            </Typography>

            {!hideNextStep && (
              <Typography variant="h6" component="span" className={styles.nextStep}>
                <Skeleton variant="text" animation="wave" width={80} />
              </Typography>
            )}
          </div>

          <Skeleton variant="rect" animation="wave" width="100%" height={5} />
        </div>

        {!hideActions && (
          <div className={styles.actions}>
            <div className={styles.actionItem}>
              <Skeleton variant="rect" animation="wave" width="100%" height={33} />
            </div>

            <div className={styles.actionItem}>
              <Skeleton variant="rect" animation="wave" width="100%" height={33} />
            </div>
          </div>
        )}
      </div>
    </Paper>
  );
});
